$(function() {
	if ($(window).width() > 768) {
		$('.portfolio__group-item').mouseover(function () {
			$('.portfolio__group-item').removeClass('portfolio__group-item_active');
			$(this).addClass('portfolio__group-item_active');
			var data = $(this).data('portfolio');
			$('.portfolio__preview-item').removeClass('portfolio__preview-item_active');
			$('.portfolio__preview-item[data-portfolio=' + data + ']').addClass('portfolio__preview-item_active');
		});

		// $('.portfolio__group-item').mouseleave(function () {
		// 	$('.portfolio__group-item').removeClass('portfolio__group-item_active');
		// 	$('.portfolio__preview-item').removeClass('portfolio__preview-item_active');
		// });
	}
})